import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { fullName } from '../../../common/helpers/users';
import Money from '../../../common/money';
import { getById } from '../../../main/barbers/selector';
import Spinner from '../../../main/customers/customersList/spinner';
import { isCashOutTipsShortcutEnabled, paymentDepositsEnabled } from '../../selectors';
import CashTipsPayoutInput from './CashTipsPayoutInput';
import { t } from '../../../../modules/infra/i18n';

const SalesSummary = (props) => (
  <div className="o-flexbox__item--flex-1 c-data-panel u-color-white u-p u-border-radius">
    <div className="c-summary-heading u-mb">
      <span className="c-label-new">
        {props.selectedBarberId
          ? `${fullName(props.selectedBarber)}${t('register:summary.sales_summary.barber_summary_suffix')}`
          : t('register:summary.sales_summary.shop_summary')}
      </span>
    </div>
    {props.isLoading ? (
      <div className="o-flexbox o-flexbox--justify-center">
        <Spinner />
      </div>
    ) : (
      <>
        <div className="c-summary-item">
          <span>{t('register:summary.sales_summary.sales')}</span>
          <span className="c-summary-amount">
            {props.totals && props.totals.totalTransactions}
          </span>
        </div>
        <div className="c-summary-item">
          <span>{t('register:summary.sales_summary.net_sales_services')}</span>
          <span className="c-summary-amount">
            <Money>{props.totals && props.totals.totalNetServiceSales}</Money>
          </span>
        </div>
        <div className="c-summary-item">
          <span>{t('register:summary.sales_summary.net_sales_products')}</span>
          <span className="c-summary-amount">
            <Money>{props.totals && props.totals.totalNetProductSales}</Money>
          </span>
        </div>
        {
          props.paymentDepositsEnabled && (
            <div className="c-summary-item">
          <span>{t('register:summary.sales_summary.booking_deposits')}</span>
          <span className="c-summary-amount">
            <Money>{props.totals && props.totals.totalDeposits}</Money>
          </span>
          </div>
          )
        }
        <div className="c-summary-item">
          <span>{t('register:summary.sales_summary.non_cash_tips')}</span>
          <span className="c-summary-amount">
            <Money>{props.totals && props.totals.totalPosAndSquireTips}</Money>
          </span>
        </div>
        {
          props.showCashTips && (
            <section className="c-cash-tips-payouts">
              <header className="c-cash-tips-payouts-header u-mb-">
                <span className="c-cash-tips-payouts-header__text">{t('register:summary.sales_summary.tip_payout')}</span>
                <div className="c-info-tooltip-new c-info-tooltip-new_small c-info-tooltip-new-handler">
                  <div className="c-info-tooltip-new__content">
                    {t('register:summary.sales_summary.tip_payout_tooltip')}
                  </div>
                </div>
              </header>
              <CashTipsPayoutInput
                selectedBarber={props.selectedBarber}
                tipsToPayout={props.totals && props.totals.totalPosAndSquireTips}
              />
            </section>
          )
        }
      </>
    )}
  </div>
);

SalesSummary.propTypes = {
  selectedBarberId: PropTypes.string.isRequired,
  selectedBarber: PropTypes.object.isRequired,
  totals: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  showCashTips: PropTypes.bool.isRequired,
  paymentDepositsEnabled: PropTypes.bool,
};

SalesSummary.defaultProps = {
  paymentDepositsEnabled: false,
};

const mapStateToProps = (state, ownProps) => {
  const selectedBarber = getById(state, ownProps.selectedBarberId);

  return {
    selectedBarber,
    showCashTips: isCashOutTipsShortcutEnabled(state) && selectedBarber,
    paymentDepositsEnabled: paymentDepositsEnabled(state),
  };
};

export default connect(mapStateToProps)(SalesSummary);
